import { useCallback, useEffect, useState } from 'react'

const KEY = 'climatise-leaderboard:tour-completed'

export function useFirstVisit() {
  const [tourPending, setTourPending] = useState(false)

  useEffect(() => {
    try {
      const done = localStorage.getItem(KEY) === 'true'
      setTourPending(!done)
    } catch {
      setTourPending(false)
    }
  }, [])

  const finishTour = useCallback(() => {
    try { localStorage.setItem(KEY, 'true') } catch { /* ignore */ }
    setTourPending(false)
  }, [])

  const restartTour = useCallback(() => {
    try { localStorage.removeItem(KEY) } catch { /* ignore */ }
    setTourPending(true)
  }, [])

  return { tourPending, finishTour, restartTour }
}
